//tw文件
module.exports = {
  header1: "首 頁",
  header2: "關於我們",
  header2_1: "我們是誰",
  header2_2: "為什麼選擇我們",
  header3: "交易平台",
  header4: "MT5指南",
  header5: "聯繫我們",
  header6: "開設真實賬號",
  header7: "登錄",
  header8: "註冊",
  footer1: "加入交易者行列",
  footer2: "免費試用",
  footer3: "立即開始交易",
  footer4: "關注我們",
  footer5: "版權所有",
  footer6: "保留所有權利",
  home1: "交易產品",
  home2: "入金免手續費",
  home3: "低至零點差",
  home4: "隨處皆可進行交易",
  home5: "超過200種可交易產品",
  home6: "9種時間段選項",
  home7: "可在Pc和Mobile 上登錄賬戶",
  home8: "專業的分析工具",
  home9: "下載PC版MT5",
  home10: "網絡交易者",
  home11: "無需下載或安裝",
  home12: "在任何網絡瀏覽器上訪問您的帳戶",
  home13: "與MT4一樣功能強大",
  home14: "隨時隨地連接市場進行交易",
  home15: "開啟網頁版mt5",
  home16: "幫助您做出",
  home17: "最佳的交易決策",
  home18: "使用這些交易工具來幫助您做出最明智的決定",
  home19: "智能交易系統",
  home20: "通過專業的EA獲得交易優勢",
  home21: "交易信號",
  home22: "如燈塔般指引你贏向成功。 ",
  home23: "經濟日曆",
  home24: "掌握最新的市場趨勢",
  home25: "Protrader工具",
  home26: "獲取更多交易機會",
  home27: "市場消息",
  home28: "精選市場觀點",
  home29: "分析師觀點",
  home30: "專業版經濟日曆",
  home31: "開設交易賬號並至少入金1000美元",
  home32: "即可使用全套專業交易工具",
  home33: "即刻入金",
  home34: "開設真實賬戶",
  home35: "完美體驗",
  home36: "極速執行交易訂單",
  home37:
    "“什麼是交易者選擇外匯經紀人時的關鍵要素?”–這是我們在建立{platform}時不斷問自己的問題。我們認為，這些要素是定義我們的價值，使我們能夠滿足客戶需求並持續提供卓越可靠服務的核心。 ",
  home38: "5分鐘極速開戶",
  home39: "200種以上可交易商品組合",
  home40: "功能完善的賬戶管理系統",
  home41: "絕佳的市場流動性",
  home42: "了解更多",
  home43: "合規監管",
  home44: "提供最佳安全保障",
  home45:
    "{platform}非常重視監管和安全性。我們為所有客戶提供透明、安全的外匯交易環境。 ",
  home46: "全球辦事處",
  home47: "多國監管",
  home48: "世界頂尖金融機構合作",
  home49: "資金保險",
  home50: "監管",
  home51: "賠償",
  home52: "保險",
  home53: "入金方式",
  home54: "市場流動性合作夥伴",
  home55:
    "{platform} 和14家以上的世界頂尖流動性報價商合作，充足的流通性能夠為您提供市場上最優異的交易報價",
  home56: "外匯交易",
  home57: "利用全球經濟動盪局勢，連接世界上流動性最強的金融市場",
  home58: "立即開始交易",
  home59: "大宗商品交易",
  home59_1: "大宗交易",
  home60: "依據主要市場交易週期選擇黃金、白銀、原油或其它軟性商品",
  home61: "指數交易",
  home61_1: "指數",
  home62:
    "透過全球大型股票指數如SP500、DJ30、FRA40和DAX30等指數的波動，進行交易",
  home63: "美國/香港 股票交易",
  home64: "掌握全球大型公司動向，以差價合約交易美國和香港的股票",
  home65: "差價合約",
  home66: "全球業務",
  home67: "為客戶提供一流、穩定的服務，是我們的榮幸",
  home68: "網頁版交易",
  who0: "誰是{platform}",
  who1: "加入最具創新的經紀人",
  who2:
    "{platform}在全球金融市場上擁有10多年經驗和專業知識，致力於提供簡單透明化的市場准入並幫助的客戶實現財務目標。 ",
  who3:
    "{platform}於2010年在英國成立，始終秉持“隨時隨地  暢享交易”的理念，運用先進的技術服務，為客戶在外匯市場中提供卓越的交易經驗，其中包括原始點差、極速執行準確交易的ECN帳戶以及強大的客戶端管理系統等。 ",
  who4: "選擇可信任的外匯經紀人",
  who5:
    "{platform1}一直致力於為客戶提供卓越的交易環境，且始終堅持抱著超越全球金融監管機構的期望。在這個行業中我們了解到，交易者渴望找到一個可以信賴的平台。 {platform2}在多個機構監管的監管下，我們積累超過10,000個來自世界各地活躍的客戶交易賬戶，他們皆倚賴{platform3}以確保其資金的安全性。 ",
  who6: "主要監管機構",
  who6_1: "美國NFA監管，註冊ID：0542569",
  who7: "全球人數",
  who8:
    "作為全球金融市場領先者之一，{platform}為我們的客戶提供頂級和穩定的服務。 ",
  who9: "以下是{platform}的一些相關數據：",
  who10: "10年+",
  who11: "行業資歷",
  who12: "1.5B以上",
  who13: "每月交易量",
  who14: "7M以上",
  who15: "客戶帳戶",
  who16: "$1.5B",
  who17: "月交易量",
  why0: "為什麼選擇{platform}",
  why1: "不僅僅是一個平台，而是一位合作夥伴",
  why2:
    "“交易者在選擇外匯經紀人時想要什麼？” –這是我們創立{platform}時不斷問自己的問題。相信這些要素是定義我們價值的核心，使我們能夠滿足客戶的需求並持續提供卓越可靠的服務。 ",
  why3:
    "最重要的是，我們希望建立一個超越價格或產品而聞名的品牌。我們希望成為新世代交易的品牌。熟知客戶的需求，讓我們可以更靈活地進行變更。我們是高效能的新世代交易平台，在您需要時{platform}總是在您身邊。 ",
  why4: "交易旅程中，我們就在您身邊",
  why5:
    "無論您是剛起步的新手或是交易多年的老手，我們的團隊隨時都會為您提供支援。我們的平台隨時隨地與您同在，我們的客戶服務團隊陪伴您邁出的每一步，我們將陪伴您一起成長。儘管我們的競爭對手可能比我們更強大，但我們有創新動力，以及合規交易平台的支持。了解為什麼{platform}是您正確的選擇：",
  why6: "5分鍾立即開通真實帳戶",
  why7: "槓桿高達500：1",
  why8: "可交易200種以上的商品",
  why9: "提供額外的交易贈金",
  why10: "強大的客戶端管理系統",
  why11: "絕佳的市場流動性",
  why12: "多個監管機構和分離賬戶作為擔保",
  trading1: "使用Metatrader5平台",
  trading2: "隨時隨地進行交易",
  trading3:
    "若您是{platform}的新客戶，只需填寫此頁面頂部的表格，就可以在幾分種之內使用MT5交易平台。 ",
  trading4:
    "如果您已經是在MT5平台上進行交易的{platform}客戶，只需要登錄您的客戶管理後台，點擊打開賬戶並選擇MetaTrader5，即可無縫切換至MT5，進一步提升您的交易體驗。 ",
  trading5: "MT5移動App讓您隨時隨地的連接到{platform}，享受全天候的交易服務。 ",
  guide0: "MT5指南",
  guide1: "在您的電腦下載MT5",
  guide3: "如何插入圖表名額？ ",
  guide3_0: "按以下步驟進行操作：",
  guide3_1: "1）在頂端功能表列上，選擇插入名額。 ",
  guide3_2: "2）您也可以從導航部分插入名額。 ",
  guide4: "如何規避防火牆保護？ ",
  guide4_1:
    "禁止您的反病毒防火牆申請MetaTrader 4，打開1950埠。申請MetaTrader 5的則打開443埠。 ",
  guide5: "我如何創建趨勢線和其他線的研究？ ",
  guide5_1: "1）在頂端功能表列上，選擇“插入”",
  guide5_2: "2）選擇想要的趨勢線。 ",
  guide5_3:
    "3）釋放滑鼠按鈕後，將出現帶有十字準線的選中趨勢線的影像圖標。使用滑鼠把十字準線放在選中的圖表上。點擊滑鼠，按住不放進行移動滑鼠來調整趨勢線的大小。 ",
  guide5_4:
    "線研究的快捷方式也可通過點擊“瀏覽”工具列線研究快速訪問，讓圖標剛好在功能表列下顯現。 ",
  guide5_5:
    "您也可以選擇出現在熒幕頂端的其他選項。包括點擊趨勢線、十字準線、斐波納契回檔線等。 ",
  guide6: "如何顯示條形圖？ ",
  guide6_1: "在頂端的功能表列中，選擇“圖表條形圖”或使用鍵盤快捷方式（Alt+1）",
  guide7: "如何獲取帳戶資訊和Metatrader平台的日常交易？ ",
  guide7_1:
    "請使用平台的終端（TERMINAL）部分。如果您不打開這個部分，可以通過瀏覽終端TERMINAL或使用鍵盤快捷方式Cntrl+t。 ",
  guide7_2: "在終端部分，選擇“帳戶歷史標記”。 ",
  guide7_3: "這一標記向您顯示了帳戶的歷史，為方便起見也可進行列印。 ",
  guide7_4: "在本部分任何地方點擊滑鼠右鍵。 ",
  guide7_5:
    "選擇“以報告保存”。 （也可以以HTML檔案保存，這種檔案可以轉換為Excel檔案留作記錄。）",
  guide8: "如何顯示燭柱圖？ ",
  guide8_1:
    "在頂端的功能表列上，選擇“圖表燭柱圖”或使用鍵盤快捷方式（Alt+2）。 ",
  guide9:
    "我可以在你們的系統上使用MetaTrader應用程序介面嗎？這可以先在迷你/類比帳戶上進行嗎？ ",
  guide9_1:
    "可以，只要您希望，就可以首先使用類比帳戶進行。通常，特定的條款和條件適用於應用程序介面對真實係統的訪問。請確保您與FXDD代表探討了您的項目，這樣一來，他們就可以向您提供幫助。 ",
  guide10: "如何顯示線圖？ ",
  guide10_1: "在頂端的功能表列上，選擇“圖表線圖”或使用鍵盤快捷方式（Alt+3）。 ",
  guide11: "怎樣拉近或拉遠圖表？ ",
  guide11_1: "1）確保“圖表”工具列已經啟用",
  guide11_2: "2）接下來，選擇在功能表列下定位的合理行動的圖標，即‘+’and‘-‘.",
  guide11_3: "3）選擇兩個圖標中的一個拉近或拉遠圖標。 ",
  guide11_4:
    "或者，對此功能使用鍵盤快捷方式。拉近為（Shift +），拉遠為（-）。 ",
  guide12: "MetaTrader平台有助於迷你手（10K）的交易嗎？ ",
  guide12_1: "是的，您可以使用MetaTrader平台進行迷你手（10K）的交易。 ",
  guide12_2: "以下是我們在Metatrader上用於交易手數大小的範圍：",
  guide12_3: "0.01手=1000組織的基準貨幣（或美元）我們的“超迷你”手。 ",
  guide12_4: "0.10手=10000組織基準貨幣（或美元）我們的“迷你”手。 ",
  guide12_5: "1.00手=100000組織基準貨幣（或美元）我們的“標準”手。 ",
  guide13: "我已經下載了平台。如何登入到我的真實帳戶中進行交易呢？ ",
  guide13_1:
    "用戶應已收到帳戶准予的電子郵件通知，通知上註明了登錄名和密碼（即登錄名為“81234”，密碼為“xxxxx”）。這就是您的真實帳戶的帳戶資訊。如果您下載了平台，打開登入屏。注意，這時打開的熒幕會要求您開設一個帳戶。您可以點擊“X”退出此屏。 ",
  guide13_2: "登入時，選擇“檔案登入”，鍵入您的登錄名和密碼。 ",
  guide13_3:
    "服務器欄位擁有一個下拉式菜單，選擇以下服務器：‘FXDD-MT5 Live Server 2 - FXDD’。 ",
  guide13_4: "注意聽“叮”的聲音（確認音），您的帳號將在平台的左上角顯現。 ",
  guide13_5:
    "如果您看見價格在Market Watch中移動，且終端部分顯示正確的餘額時，標明您已成功登入到您的真實帳戶。如果您在登入時遇到問題，請發送電子郵件至support@leedword.com。 ",
  guide14: "我如何在MetaTrader上修改密碼？ ",
  guide14_1: "在頂端的功能表列上，選擇“工具選項”或鍵盤快捷方式（Ctrl+O）。 ",
  guide14_2: "在“服務器”圖標下，選擇“修改”。 ",
  guide14_3: "在“當前密碼”文字欄位中輸入當前密碼。 ",
  guide14_4: "在“修改主密碼”那裡打勾。 ",
  guide14_5: "在“新密碼”文字欄位中輸入新密碼。 ",
  guide14_6: "在第二個“確認”文字欄位中重新鍵入新密碼。 ",
  guide15: "怎樣選擇使用語言？ ",
  guide15_1:
    "在頂端功能表列上，選擇“瀏覽語言”，選擇您偏好的語言。然後關閉平台重開程式即可。 ",
  guide16: "要在平台上顯示不同的視窗，可以使用哪些鍵盤快捷方式？ ",
  guide16_1: "最常使用的鍵盤快捷方式有：",
  guide16_2: "Ctrl+M=市價觀察視窗",
  guide16_3: "Ctrl+N=導航視窗",
  guide16_4: "Ctrl+T=終端視窗",
  guide17: "我如何查看FXDD提供的所有貨幣對？ ",
  guide17_1:
    "在Market Watch視窗中，右擊並選擇“顯示全部”，就可以查看可以進行交易的所有貨幣對了。所有的貨幣對隨即便可顯現。 ",
  guide18: "我如何在Market Watch視窗中顯示高/低價？ ",
  guide18_1: "在Market Watch視窗中，按照以下步驟顯示高/低價格：",
  guide18_2: "在Market Watch視窗中右擊（任何部分）",
  guide18_3: "選擇“高”/“低”。 （這時將出現當日各貨幣對的高低價格。）",
  guide19: "你們可以引導建立圖表嗎？有哪些選擇？ ",
  guide19_1:
    "可以，MetaTrader 5平台是市場上最先進的平台之一，其中的製圖選項和包尤其如此。 ",
  guide19_2:
    "使用幫助選單（按F1）下的“幫助主題”選項，標記“與圖表開始工作”部分。這部分應作為一個良好起步的開始。 ",
  guide19_3:
    "您可以變更圖表的整體外觀（“功能表列”—“圖表”—“內容”）。您可以變更背景、前景、表格等的顏色。您可以滾動圖表視窗的邊緣調整圖表大小，下拉滑鼠按鈕調整大小。 ",
  guide20: "如何修改MetaTrader圖表的顯示時間週期？ ",
  guide20_1:
    "對主菜單欄添加時限時，選擇“瀏覽工具列”。 “週期”（如果需要）。使用以下圖例將時限用於圖表中：",
  guide20_2: "M1=1分鐘的圖表",
  guide20_3: "M5=5分鐘的圖表",
  guide20_4: "M15=15分鐘的圖表",
  guide20_5: "M30=30分鐘的圖表",
  guide20_6: "H1=1小時的圖表",
  guide20_7: "H4=4小時的圖表",
  guide20_8: "D1=每日圖表",
  guide20_9: "W1=每週圖表",
  guide20_10: "MN=每月圖表",
  guide21: "Metatrader 5.0有使用者指南嗎？ ",
  guide21_1:
    "有的，在平台選擇“幫助幫助主題”或者您可以點擊這裡進行下載。請注意，我們設有線上研討會，可以幫助您了解這一平台的功能。如果您想參加這些線上研討會，請發送電子郵件至銷售部。 ",
  guide22: "Metatrader平台上的時區是什麼？這一時間可以進行調整嗎？ ",
  guide22_1:
    "夏令時，客戶在MetaTrader上的時間為GMT+3（格林尼治標準時間加上3小時，北京時間加5小時）。很遺憾的是，MetaTrader平台上的時間無法變更。對此造成的任何不便，我們深感抱歉。 ",
  guide23: "如何在MetaTrader平台上再開設一個類比帳戶？ ",
  guide23_1: "在平台中選擇“檔案開設一個帳戶”",
  guide23_2: "填寫要求的資訊（務必要在“我同意訂閱你們的簡訊”欄中打勾）",
  guide23_3: "選擇“下一步”（在服務器頁上）",
  guide23_4: "選擇“下一步”（請注意，您的用戶名和密碼將會顯現）",
  guide23_5: "選擇“完成”",
  guide23_6: "這一軟件將會讓您自動登錄到您新的類比帳戶，在導航視窗查看。 ",
  guide24: "影響程式中往來通信量的因素是什麼？ ",
  guide24_1:
    "輸出的通信量取決於用戶的活動，數量相當少。輸入的通信量直接取決於打開的圖表視窗的數量。 ",
  guide25: "我可以通過電子郵件接收警告嗎？ ",
  guide25_1: "遵循以下步驟在MetaTrader 5中創建電子郵件警告：",
  guide25_2:
    "（所有簡單郵件傳送協議（SMTP）的設定因互聯網服務供應商而各不相同。如果您收到錯誤資訊，聯繫您的互聯網服務供應商的技術支援，請求他們進行簡單郵件傳送協議的設定。如果您使用Outlook，可以選擇“工具電子郵件帳戶下一步修改”完成時取消）進行簡單郵件傳送協議的設定。 ",
  guide25_3: "選擇“工具選項”。 ",
  guide25_4: "選擇”電子郵件”圖標。 ",
  guide25_5:
    "根據您的互聯網服務供應商的要求編輯上述設定。通常，淡紅色文字是您應該登入的一般準則。具體說明請聯繫您的互聯網服務供應商。 （注意：無法使用的網絡電子郵件服務有Hotmail，Yahoo，Gmail等）",
  guide25_6: "簡單郵件傳送協議服務器-這是您的互聯網服務供應商的郵件伺服器地址",
  contact1: "當您需要我們時，我們總是在您身邊",
  contact2:
    "如果您有任何疑問或需要更多協助，請通過以下聯繫方式與我們聯繫。我們將盡力盡快答复所有問題。 ",
  contact3: "注冊地址",
  contact4: "開曼辦事處",
  contact5: "辦事處",
  contact6: "台灣台北信義區五段7號(台北101)",
  contact7: "電子郵件地址",
  contact8: "聯繫電話",
  address1: "澳大利亞，悉尼",
  address2: "台北",
  address3: "泰國，曼谷",
  address4: "馬來西亞，吉隆坡",
  address5: "英國，倫敦",
  address6: "美國，紐約",
  address7: "新加坡，新加坡市",
  address8: "開曼群島，喬治城",
  address9: "塞浦路斯，尼科西亞",
  address10: "香港",
  address11: "越南，河內",
  address12: "澳大利亞，墨爾本"
};



// WEBPACK FOOTER //
// ./src/common/lang/tw.js